export var FocusOn = function ($timeout) {
    'ngInject';
    return {
        restrict: 'A',
        link: function ($scope, $element, $attrs) {
            $scope.$on('focusOn', function (e, name) {
                $timeout(function () {
                    if (name === $attrs.focusOn) {
                        $element[0].focus();
                    }
                }, 250);
            });
        },
    };
};
//# sourceMappingURL=focus-on.directive.js.map